import styled from 'styled-components';

import PrebookingRow from './component';

export default styled(PrebookingRow)`
  height: 42px;
  width: 100%;
  background: #fff;

  .cell {
    line-height: normal;
    padding: 0 12px;
    border-bottom: 1px solid var(--grey100);
    &--center {
      text-align: center;
    }
    &--right {
      text-align: right;
    }
    &--dark {
      background-color: var(--grey100);
      color: var(--grey700);
    }
    &--border {
      border-right: 1px solid var(--grey300);
    }
    &--nopadding {
      padding: 0;
    }
    .show-on-hover {
      display: none;
    }
  }

  &:hover {
    .cell {
      background-color: var(--grey100);
      border-bottom: 1px solid var(--grey200);
      &--dark {
        background-color: var(--grey200);
      }

      .show-on-hover {
        display: block;
      }
    }
    .slots {
      .slot {
        border-right: 1px solid var(--grey200);
      }
    }
  }

  .hint {
    &--light {
      color: var(--grey700);
    }
  }

  .status {
    display: flex;
    height: 42px;

    .status-box {
      height: 42px;
      border-right: 1px solid var(--grey100);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 12px;
    }
  }

  .launch-cell {
    display: flex;
    align-items: center;

    &--right {
      justify-content: flex-end;
    }

    &--left {
      justify-content: flex-start;
    }

    &--launched {
      color: var(--success700);
      font-weight: bold;
    }

    input {
      border: 1px solid var(--grey500);
      width: 32px;
      height: 24px;
      outline: none;
      text-align: center;
      &:focus {
        border: 1px solid var(--primary700);
      }
      &:disabled {
        opacity: 0.5;
      }
    }

    .button {
      padding: 0;
    }

    .loading {
      margin-right: 8px;
    }
  }
`;
